import { Button, Card } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCompressAlt, faExpandAlt } from '@fortawesome/free-solid-svg-icons'
import styles from './RightBarButtonsPanel.module.scss'

type Props = {
    onSave: () => void
    onCancel: () => void
    isButtonsShakeAnimated: boolean
    isSaveDisabled?: boolean
    className?: string
} & (
    | { isFullScreen: boolean; onFullScreen: () => void }
    | { isFullScreen: undefined; onFullScreen?: never }
)

export const RightBarButtonsPanel = ({
    onSave,
    onCancel,
    isButtonsShakeAnimated,
    isSaveDisabled,
    className,
    onFullScreen,
    isFullScreen,
}: Props) => {
    return (
        <Card.Footer className={`d-flex align-items-center ${className}`}>
            <button
                disabled={!!isSaveDisabled}
                onClick={onSave}
                type="button"
                className={`app-btn-main app-btn-apply ${isButtonsShakeAnimated && styles.shakeAnimation}`}
            >
                Save
            </button>
            <button
                onClick={onCancel}
                className={`ms-2 app-btn-main app-btn-cancel ${isButtonsShakeAnimated && styles.shakeAnimation}`}
                type="button"
            >
                Cancel
            </button>
            {isFullScreen === undefined ? (
                <></>
            ) : (
                <Button
                    variant="outline-dark"
                    className="ms-auto app-btn-full-screen"
                    onClick={onFullScreen}
                >
                    <FontAwesomeIcon
                        icon={!isFullScreen ? faExpandAlt : faCompressAlt}
                    />
                </Button>
            )}
        </Card.Footer>
    )
}
